
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'

export default {
name: "grid-box",
components: {
Popup,
},
data() {
return {
index:1,
show:false,
moduleName:'',
}
},
directives: {
TransferDom
},
props:['list','selected'],

methods: {
itemTab(index){
this.index=index;
this.$emit('on-click',index)
},
itemClick(routerLink,i){
this.index=i+1;
this.$emit('on-click',routerLink)
},
indexOf(str,par){
if(!str){
str = '';
}
return str.indexOf(par) != -1;
},

showSupModule(item){
if(item.moduleName.indexOf('BASIC_INFO') > -1){
this.moduleName = "BASIC_INFO";
}else if(item.moduleName.indexOf('MANAGE_INFO') > -1){
this.moduleName = "MANAGE_INFO";
}else if(item.moduleName.indexOf('SUP_ADDRESS') > -1){
this.moduleName = "SUP_ADDRESS";
}else if(item.moduleName.indexOf('SUP_AGENCY') > -1){
this.moduleName = "SUP_AGENCY";
}else if(item.moduleName.indexOf('SUP_BANK') > -1){
this.moduleName = "SUP_BANK";
}else if(item.moduleName.indexOf('SUP_COMPANY') > -1){
this.moduleName = "SUP_COMPANY";
}else if(item.moduleName.indexOf('SUP_CONTACT') > -1){
this.moduleName = "SUP_CONTACT";
}else if(item.moduleName.indexOf('SUP_BILL_INFO') > -1){
this.moduleName = "SUP_BILL_INFO";
}else if(item.moduleName.indexOf('SUP_OPERATION') > -1){
this.moduleName = "SUP_OPERATION";
}else if(item.moduleName.indexOf('SUP_PURORG') > -1){
this.moduleName = "SUP_PURORG";
}else if(item.moduleName.indexOf('SUP_SKILL') > -1){
this.moduleName = "SUP_SKILL";
}else if(item.moduleName.indexOf('SUP_QUAL') > -1){
this.moduleName = "SUP_QUAL";
}else if(item.moduleName.indexOf('RESERVED_5') > -1){
this.moduleName = "RESERVED_5";
}else if(item.moduleName.indexOf('RESERVED_4') > -1){
this.moduleName = "RESERVED_4";
}else if(item.moduleName.indexOf('RESERVED_3') > -1){
this.moduleName = "RESERVED_3";
}else if(item.moduleName.indexOf('RESERVED_2') > -1){
this.moduleName = "RESERVED_2";
}else if(item.moduleName.indexOf('RESERVED_1') > -1){
this.moduleName = "RESERVED_1";
}else if(item.moduleName.indexOf('SUP_SUPPLY_CAT') > -1){
this.moduleName = "SUP_SUPPLY_CAT";
}
this.show = false;
},
showMore(){
this.show = true;
}


},



}



// WEBPACK FOOTER //
// ./src/components/grid-box.vue